import { IHttpClient } from '../../services/HttpClient/IHttpClient';
import {
  GetCompletedSurveysRequest,
  GetCompletedSurveysResponse,
  GetCurrentSurveyRequest,
  GetCurrentSurveyResponse,
  GetPendingSurveysRequest,
  GetPendingSurveysResponse,
  GetSurveyDetailRequest,
  GetSurveyDetailResponse,
  SubmitSurveyAnswersRequest,
  SubmitSurveyAnswersResponse,
} from './survey.models';
import {
  GetUserKpiScoresRequest,
  GetUserKpiScoresResponse,
} from './kpi.models';
import { ISurveyApi } from './ISurveyApi';

export class SurveyApi implements ISurveyApi {
  constructor(private readonly httpClient: IHttpClient) {}

  public readonly getCurrentSurvey = (
    request: GetCurrentSurveyRequest
  ): Promise<GetCurrentSurveyResponse> => {
    const { companyId } = request;
    return this.httpClient.get<GetCurrentSurveyResponse>(
      `/pulse-survey/company/${companyId}/current-survey`,
      {
        isAuthorized: true,
      }
    );
  };

  public readonly getPendingSurveys = (
    request: GetPendingSurveysRequest
  ): Promise<GetPendingSurveysResponse> => {
    const { companyId } = request;
    return this.httpClient.get<GetPendingSurveysResponse>(
      `/pulse-survey/company/${companyId}/pending-surveys`,
      {
        isAuthorized: true,
      }
    );
  };

  public readonly getSurveyDetail = (
    request: GetSurveyDetailRequest
  ): Promise<GetSurveyDetailResponse> => {
    const { companyId, surveyId } = request;
    return this.httpClient.get<GetSurveyDetailResponse>(
      `/pulse-survey/company/${companyId}/survey/${surveyId}`,
      {
        isAuthorized: true,
      }
    );
  };

  public readonly submitSurveyAnswers = (
    request: SubmitSurveyAnswersRequest
  ): Promise<SubmitSurveyAnswersResponse> => {
    const { companyId, surveyId, answers, isAnonymous } = request;
    return this.httpClient.post<SubmitSurveyAnswersResponse>(
      `/pulse-survey/company/${companyId}/survey/${surveyId}/answer`,
      {
        isAuthorized: true,
        body: { answers, isAnonymous },
      }
    );
  };

  public readonly getCompletedSurveys = (
    request: GetCompletedSurveysRequest
  ): Promise<GetCompletedSurveysResponse> => {
    const { companyId } = request;
    return this.httpClient.get<GetCompletedSurveysResponse>(
      `/pulse-survey/company/${companyId}/completed-surveys`,
      {
        isAuthorized: true,
      }
    );
  };

  public readonly getUserKpiScores = (
    request: GetUserKpiScoresRequest
  ): Promise<GetUserKpiScoresResponse> => {
    const { companyId } = request;
    return this.httpClient.get<GetUserKpiScoresResponse>(
      `/pulse-survey/company/${companyId}/user-kpi-scores`,
      {
        isAuthorized: true,
      }
    );
  };
}
